
import React from "react";
import type { RouteObject } from "react-router-dom";

import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import DemoPage from "../pages/demo/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";
import BlogPage from "../pages/blog/page";
import PrivacyPage from "../pages/privacy/page";
import TermsPage from "../pages/terms/page";
import HowAIReceptionistsWorkPage from "../pages/blog/how-ai-receptionists-work/page";
import StartFreeTrialPage from "../pages/start-free-trial/page";
import SmsOptInPage from "../pages/sms-opt-in/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/demo",
    element: <DemoPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/blog/how-ai-receptionists-work",
    element: <HowAIReceptionistsWorkPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "/terms",
    element: <TermsPage />,
  },
  {
    path: "/start-free-trial",
    element: <StartFreeTrialPage />,
  },
  {
    path: "/sms-opt-in",
    element: <SmsOptInPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
